// src/pages/CategoryPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../services/firebase"; // ✅ chemin corrigé
import WineCard from "../components/WineCard";
import "../styles/styles.css";

export default function CategoryPage() {
  const { id } = useParams();
  const catId = decodeURIComponent(id || ""); // ✅ au cas où encodé

  const [category, setCategory] = useState(null);
  const [wines, setWines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function run() {
      setLoading(true);
      try {
        // 1️⃣ Récupération de la catégorie
        const ref = doc(db, "categoriesWine", catId);
        const snap = await getDoc(ref);
        if (!snap.exists()) {
          setCategory(null);
          setWines([]);
          setLoading(false);
          return;
        }
        const cat = { id: snap.id, ...snap.data() };
        setCategory(cat);

        // 2️⃣ Chargement des vins correspondant
        const winesCol = collection(db, "winesek");
        let list = [];

        // Priorité : par categoryId (si tu as ce champ dans les vins)
        try {
          const byIdQ = query(winesCol, where("categoryId", "==", catId));
          const byIdSnap = await getDocs(byIdQ);
          list = byIdSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
        } catch (e) {
          console.warn("Pas de champ categoryId sur les vins");
        }

        // Fallback : par nom de catégorie
        if (list.length === 0 && cat.name) {
          try {
            const byNameQ = query(winesCol, where("category", "==", cat.name));
            const byNameSnap = await getDocs(byNameQ);
            list = byNameSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
          } catch (e) {
            console.warn("Filtrage par nom non disponible");
          }
        }

        setWines(list);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    if (catId) run();
  }, [catId]);

  if (loading)
    return (
      <div className="container py-4">
        <p>Chargement…</p>
      </div>
    );

  if (!category)
    return (
      <div className="container py-4">
        <div className="alert alert-warning">
          Catégorie introuvable. <Link to="/">Retour</Link>
        </div>
      </div>
    );

  return (
    <div className="container py-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h1 className="h4 m-0 text-uppercase">{category.name}</h1>
        <Link to="/" className="btn btn-sm btn-outline-dark">
          ← Retour
        </Link>
      </div>

      {category.imageUrl && (
        <div className="mb-3">
          <img
            src={category.imageUrl}
            alt={category.name}
            className="img-fluid rounded shadow-sm"
          />
        </div>
      )}

      {/* 🏷️ Affichage des types comme labels */}
      {category.types && category.types.length > 0 && (
        <div className="mb-4">
          <h6 className="text-muted mb-2">Types disponibles :</h6>
          <div className="d-flex flex-wrap gap-2">
            {category.types.map((type) => (
              <Link
                key={type}
                to={`/type/${encodeURIComponent(type)}`}
                className="badge bg-light text-dark border border-secondary px-3 py-2 fw-semibold type-badge"
              >
                {type.toUpperCase()}
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Liste des vins */}
      {wines.length === 0 ? (
        <div className="text-muted">Aucun vin trouvé pour cette catégorie.</div>
      ) : (
        <div className="row">
          {wines.map((wine) => (
            <div key={wine.id} className="col-6 col-md-4 col-lg-3 mb-4">
              <WineCard wine={wine} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}